module.exports = __webpack_public_path__ + "img/ms.e327d034.svg";